import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import { useGlobal } from '@rcg/ui-react';
import useDictionary from '../../../hooks/useDictionary';
import Dictionary from '../../../utils/dictionary';
import { isFlexibilityService, isBaggageService } from '../../../utils/inflightServices';

const MAX_VISIBLE = 4;

const useStyles = makeStyles((Theme) => ({
  section: {
    flex: '1 0 0',
    alignSelf: 'stretch',
    marginBottom: '12px',
  },
  title: {
    fontFamily: Theme.typography.base.bold,
    fontSize: Theme.typography.size[0],
    fontWeight: 700,
    lineHeight: '16px',
    color: '#083870',
    margin: '0 0 6px 0',
  },
  item: {
    display: 'flex',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    flex: '1 0 0',
    gap: '6px',
    marginBottom: '4px',
    fontFamily: Theme.typography.base.regular,
    fontSize: Theme.typography.size[0],
    fontWeight: 400,
    lineHeight: '16px',
    color: '#083870',
    [Theme.breakpoints.up('md')]: {
      gap: '8px',
      marginBottom: '8px',
      lineHeight: '20px',
    },
  },
  checkIcon: {
    fontSize: '16px',
    color: Theme.palette.green,
    flexShrink: 0,
    marginTop: '2px',
    [Theme.breakpoints.up('md')]: {
      fontSize: '18px',
      marginTop: '1px',
    },
  },
  showMoreBtn: {
    display: 'block',
    cursor: 'pointer',
    color: Theme.palette.primary.main,
    fontSize: Theme.typography.size[1],
    background: 'none',
    border: 'none',
    padding: '4px 0 0 0',
    textDecoration: 'underline',
  },
}));

const AmenitiesSection = ({ inflightServices = [] }) => {
  const classes = useStyles();
  const getDictionary = useDictionary(Dictionary);
  const { renderContent } = useGlobal();
  const [showAll, setShowAll] = useState(false);

  const amenities = inflightServices.filter(
    (s) => !isFlexibilityService(s) && !isBaggageService(s),
  );

  if (amenities.length === 0) return null;

  const visible = showAll ? amenities : amenities.slice(0, MAX_VISIBLE);
  const hasMore = amenities.length > MAX_VISIBLE;

  return (
    <div className={classes.section}>
      <p className={classes.title}>{getDictionary(Dictionary.airFareAmenitiesTitle.key)}</p>
      {visible.map((s) => (
        <div key={s.key} className={classes.item}>
          <CheckIcon className={classes.checkIcon} />
          <span>{renderContent(s.key, s.value)}</span>
        </div>
      ))}
      {hasMore && (
        <button
          type="button"
          className={classes.showMoreBtn}
          onClick={() => setShowAll((prev) => !prev)}>
          {showAll
            ? getDictionary(Dictionary.airShowLessLabel.key)
            : getDictionary(Dictionary.airShowMoreLabel.key)}
        </button>
      )}
    </div>
  );
};

export default AmenitiesSection;
